let config;

if (process.env.NODE_ENV === 'production' && window.CONFIG) {
  config = window.CONFIG;
} else {
  config = {
    apiURL: 'http://docker.for.mac.localhost:5000',
    recaptchaPublicKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  };
}

export default config;